// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const omit = (propKey, { [propKey]: propValue, ...rest }) => rest;
